import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/MDButton";
import { useAuthContext } from "hooks/useAuthContext";
import { API_URL } from "../../../../config";
import { Edit } from "@mui/icons-material";
import { FormControlLabel, Switch } from "@mui/material";
import { toast } from "sonner";

const EditSupervisorPopup = ({ fetchSupervisors, supervisor, isAvailable }) => {
  const { user } = useAuthContext();
  const [open, setOpen] = useState(false);
  const [supervisorData, setSupervisorData] = useState("");
  const [availability, setAvailability] = useState(false);

  useEffect(() => {
    if (supervisor) {
      setSupervisorData(supervisor.first_name);
      setAvailability(isAvailable);
    }
  }, [supervisor]);

  const handleToggleChange = async (event) => {
    const newAvailability = event.target.checked;
    setAvailability(newAvailability);

    try {
      const response = await fetch(
        `${API_URL}/supervisors/updateavailability/${supervisor.email}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
          body: JSON.stringify({ is_available: newAvailability }),
        }
      );

      if (!response.ok) {
        console.log(response);
        
        toast.error("Failed to update supervisor availability");
      } else {
        toast.success("Success", {
          description: "Supervisor availability updated successfully",
        });
      }
    } catch (error) {
      toast.error("Failed to update supervisor availability" + error.message);
    } finally {
      fetchSupervisors();
      setOpen(false);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Edit
        sx={{ cursor: "pointer", fontWeight: "bold" }}
        fontSize="small"
        color="warning"
        onClick={handleClickOpen}
      />
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Supervisor</DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              control={
                <Switch
                  checked={availability}
                  onChange={handleToggleChange}
                  color="primary"
                />
              }
              label={availability ? "Available" : "Not Available"}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose}>Close</MDButton>
          <MDButton
            onClick={handleToggleChange}
            variant="contained"
            color="info"
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EditSupervisorPopup;
